import { render, staticRenderFns } from "./BillingChargeAmount.vue?vue&type=template&id=3a34b5ef"
import script from "./BillingChargeAmount.vue?vue&type=script&lang=js"
export * from "./BillingChargeAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports